import React, { useEffect, useLayoutEffect } from 'react';
// Import the BrowserRouter, Route and Link components
import {Helmet} from "react-helmet";
import RouterContainer from './RouterContainer';
import ScrollToTop from "./ScrollToTop";
import { ScreenClassProvider, setConfiguration} from 'react-grid-system';
import Nav, { CyclingBlurb, ExperimentsNavItem } from './Nav';
import Footer, { footerLinks } from './Footer';
import blurbs from './blurbs';
import DrawingOverlay from './components/DrawingOverlay';
import Favicon3D from './components/Favicon3D';
import { useLocation } from 'react-router-dom';
import './App.css';

setConfiguration({
  breakpoints: [576, 768, 1050, 1200, 1600],
  containerWidths: [540, 740, 960, 1400, 1700],
  gutterWidth: 12,
});

const SPECIAL_PATHS = ['/', '/commissions', '/experiments', '/info'];

function App({ location }) {
  const loc = useLocation();
  const [footerVisible, setFooterVisible] = React.useState(true);
  useLayoutEffect(() => { setFooterVisible(false); }, [loc.pathname]);
  useEffect(() => {
    const id = setTimeout(() => setFooterVisible(true), 50);
    return () => clearTimeout(id);
  }, [loc.pathname]);

  // Grey bottom overscroll for standalone project pages
  useEffect(() => {
    const isProjectPage = !SPECIAL_PATHS.includes(loc.pathname) &&
      !document.documentElement.classList.contains('page-light');
    if (!isProjectPage) return;

    let rafId = null;
    const update = () => {
      const scrollBottom = window.scrollY + window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const nearBottom = scrollBottom > docHeight - 300;
      const bg = nearBottom ? '#e0e0e0' : '';
      document.documentElement.style.backgroundColor = bg;
      document.body.style.backgroundColor = bg;
    };
    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => { rafId = null; update(); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafId) cancelAnimationFrame(rafId);
      // Don't clear if the incoming page has already claimed the background
      if (!document.documentElement.classList.contains('page-light') &&
          !document.documentElement.classList.contains('page-grey')) {
        document.documentElement.style.backgroundColor = '';
        document.body.style.backgroundColor = '';
      }
    };
  }, [loc.pathname]);  // eslint-disable-line

  return (

	<ScreenClassProvider>
	  	<ScrollToTop />
	  	<div className="App" style={
  loc.pathname === '/commissions' ? { backgroundColor: '#085C34' } :
  loc.pathname === '/experiments' ? { backgroundColor: '#e0e0e0' } :
  undefined
}>

	  	  	<Helmet>
		        <meta charSet="utf-8" />
		        <title>Maria Chimishkyan</title>
		        <link rel="canonical" href="http://mysite.com/example" />
		    </Helmet>
			<div className="app-content" style={{ position: 'relative', zIndex: 2 }}>
				<RouterContainer/>
				<Nav pathname={loc.pathname}/>
			</div>
			{(() => {
				const footerBg = loc.pathname === '/commissions' || loc.pathname === '/' ? '#085C34' : loc.pathname === '/info' ? '#000' : '#e0e0e0';
				const dark = footerBg === '#000' || footerBg === '#085C34';
				return <>
					<div className="mobile-nav-footer" style={{ backgroundColor: footerBg, color: dark ? '#fff' : '#000', opacity: footerVisible ? 1 : 0 }}>
						<div className="nav-blurb"><ExperimentsNavItem pathname={loc.pathname} /></div>
						<div style={{ marginTop: '20px' }}>
							{footerLinks.map(({ label, href }) => (
								<div className="nav-blurb" key={label}>
									{href ? <a href={href} className={dark ? 'footer-white' : 'footer-black'}>{label}</a> : label}
								</div>
							))}
						</div>
						<div className="nav-blurb" style={{ marginTop: '20px' }}><CyclingBlurb blurbs={blurbs} /></div>
					</div>
					<Footer bgColor={footerBg} visible={footerVisible} />
				</>;
			})()}
			<DrawingOverlay active={false} />
		<Favicon3D />

	      </div>


	</ScreenClassProvider>
  );
}

export default App;
